import {
  colors,
  ImpButtonProps,
  ImpSpacer,
  ImpText,
  useSnackbar,
} from '@imprint-payments/imprint-ui';
import { TEMP_SNACKBAR_DURATION } from '@imprint-payments/imprint-ui/dist/Organisms/ImpSnackbar/ImpSnackbarTypes';
import { useState } from 'react';

import { useImpState } from '../../app/hooks';
import { FORM_BUTTON_WIDTH } from '../../assets/consts/const';
import CardWithDetails from '../../components/cardDetails/CardWithDetails';
import OnboardingLayout from './OnboardingLayout';

export interface CopyCvvContent {
  title: string;
  subtitle: string;
  copyButtonText: string;
  skipButtonText: string;
  copySuccessText: string;
}

export interface CopyCvvPageProps {
  content: CopyCvvContent;
  onNext: () => void;
}

export default function CopyCvvPage({ content, onNext }: CopyCvvPageProps) {
  const { language, productAccount } = useImpState();
  const { displayTemporarySnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);

  const handleCopyCvv = () => {
    const cvv = productAccount.virtualCard?.cvv;
    if (!cvv) {
      displayTemporarySnackbar({ text: language.somethingWentWrong });
      return;
    }

    navigator.clipboard.writeText(cvv);
    displayTemporarySnackbar({
      text: content.copySuccessText,
      type: 'success',
    });
    setIsLoading(true);
    setTimeout(() => {
      onNext();
    }, TEMP_SNACKBAR_DURATION);
  };

  const buttonProps: ImpButtonProps[] = [
    {
      children: content.copyButtonText,
      variant: 'primary',
      buttonStyle: 'branded',
      state: isLoading ? 'submitting' : 'enabled',
      onClick: handleCopyCvv,
    },
    {
      children: content.skipButtonText,
      variant: 'tertiary',
      buttonStyle: 'branded',
      onClick: onNext,
    },
  ];

  return (
    <OnboardingLayout bottomButtons={buttonProps}>
      <ImpSpacer height="l" />
      <CardWithDetails
        width={FORM_BUTTON_WIDTH}
        last4={productAccount.virtualCard?.last4 || ''}
        cvv={productAccount.virtualCard?.cvv || ''}
        onCvvClick={handleCopyCvv}
      />
      <ImpSpacer height="xl" />
      <ImpText typography="headline3">{content.title}</ImpText>
      <ImpSpacer height="xs" />
      <ImpText typography="body2" color={colors.content.onSurfaceVariant}>
        {content.subtitle}
      </ImpText>
    </OnboardingLayout>
  );
}
